import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstancehlive1cpt4pr as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.p2t_1.t2t(6);
  if ($this.p2t_1.u2t() === 4) {
    $this.p2t_1.o2s('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().bc();
  $l$loop: while ($this.p2t_1.v2t()) {
    var key = $this.q2t_1 ? $this.p2t_1.x2t() : $this.p2t_1.w2t();
    $this.p2t_1.t2t(5);
    var element = $this.y2t();
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.p2t_1.z2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.p2t_1.o2s('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.p2t_1.t2t(7);
  } else if (lastToken === 4) {
    if (!$this.r2t_1) {
      invalidTrailingComma($this.p2t_1);
    }
    $this.p2t_1.t2t(7);
  }
  return new (JsonObject())(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.p2t_1.t2t(6);
  if ($this.p2t_1.u2t() === 4) {
    $this.p2t_1.o2s('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().bc();
  $l$loop: while ($this.p2t_1.v2t()) {
    var key = $this.q2t_1 ? $this.p2t_1.x2t() : $this.p2t_1.w2t();
    $this.p2t_1.t2t(5);
    var element = yield* $receiver.zs(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.p2t_1.z2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.p2t_1.o2s('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.p2t_1.t2t(7);
  } else if (lastToken === 4) {
    if (!$this.r2t_1) {
      invalidTrailingComma($this.p2t_1);
    }
    $this.p2t_1.t2t(7);
  }
  return new (JsonObject())(result);
}
function readArray($this) {
  var lastToken = $this.p2t_1.z2t();
  if ($this.p2t_1.u2t() === 4) {
    $this.p2t_1.o2s('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().p2();
  while ($this.p2t_1.v2t()) {
    var element = $this.y2t();
    result.i2(element);
    lastToken = $this.p2t_1.z2t();
    if (!(lastToken === 4)) {
      var tmp0 = $this.p2t_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.y2m_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.o2s(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.p2t_1.t2t(9);
  } else if (lastToken === 4) {
    if (!$this.r2t_1) {
      invalidTrailingComma($this.p2t_1, 'array');
    }
    $this.p2t_1.t2t(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.q2t_1 || !isString) {
    tmp = $this.p2t_1.x2t();
  } else {
    tmp = $this.p2t_1.w2t();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda_0($this)), Unit_instance);
}
var JsonTreeReader$readDeepRecursive$slambdaClass;
function JsonTreeReader$readDeepRecursive$slambda() {
  if (JsonTreeReader$readDeepRecursive$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.a2u_1 = this$0;
      }
      *b2u($this$DeepRecursiveFunction, it, $completion) {
        var tmp0_subject = this.a2u_1.p2t_1.u2t();
        var tmp;
        if (tmp0_subject === 1) {
          tmp = readValue(this.a2u_1, true);
        } else if (tmp0_subject === 0) {
          tmp = readValue(this.a2u_1, false);
        } else if (tmp0_subject === 6) {
          tmp = yield* /*#__NOINLINE__*/readObject_0(this.a2u_1, $this$DeepRecursiveFunction, $completion);
        } else if (tmp0_subject === 8) {
          tmp = readArray(this.a2u_1);
        } else {
          this.a2u_1.p2t_1.o2s("Can't begin reading element, unexpected token");
        }
        return tmp;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof DeepRecursiveScope() ? p1 : THROW_CCE();
        return this.b2u(tmp, p2 instanceof Unit() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    JsonTreeReader$readDeepRecursive$slambdaClass = $;
  }
  return JsonTreeReader$readDeepRecursive$slambdaClass;
}
function JsonTreeReader$readDeepRecursive$slambda_0(this$0) {
  var i = new (JsonTreeReader$readDeepRecursive$slambda())(this$0);
  var l = ($this$DeepRecursiveFunction, it, $completion) => i.b2u($this$DeepRecursiveFunction, it, $completion);
  l.$arity = 2;
  return l;
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.p2t_1 = lexer;
        this.q2t_1 = configuration.z2n_1;
        this.r2t_1 = configuration.l2o_1;
        this.s2t_1 = 0;
      }
      y2t() {
        var token = this.p2t_1.u2t();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.s2t_1 = this.s2t_1 + 1 | 0;
          if (this.s2t_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.s2t_1 = this.s2t_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.p2t_1.o2s('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
